import { Pill } from "@mantine/core"
import { useMemo, useState } from "react"
import { Link } from "react-router-dom"

import { DeleteViewModal } from "~/components/table/views/modals/DeleteViewModal"
import { ViewDto } from "~/gen/api"

type ViewItemProps = {
  id: string
  name: string
  currentView: ViewDto | undefined
  tableContext: string
  removeButton?: boolean
}

const PillStyle = {
  backgroundColor: "#e2dbd5",
  color: "#201c19",
}

const ActivePillStyle = {
  backgroundColor: "#4679ff",
  color: "#ffffff",
}

const ALL_VIEW_ID = "all" as const

export const ViewItem = ({
  id,
  name,
  currentView,
  tableContext,
  removeButton = true,
}: ViewItemProps) => {
  const [opened, setOpened] = useState(false)

  const linkTo = useMemo(() => {
    if (id === ALL_VIEW_ID) {
      return {} // empty object to navigate to the current page without params
    }
    return {
      search: `?viewId=${id}`,
    }
  }, [id])

  return (
    <Pill
      key={id}
      withRemoveButton={removeButton}
      onRemove={() => {
        setOpened(true)
      }}
      style={currentView?.id === id ? ActivePillStyle : PillStyle}
    >
      <Link
        to={linkTo}
        key={id}
        style={
          currentView?.id === id
            ? { color: ActivePillStyle.color }
            : { color: PillStyle.color }
        }
      >
        {name}
      </Link>
      {removeButton && (
        <DeleteViewModal
          opened={opened}
          onClose={() => {
            setOpened(false)
          }}
          viewId={id}
          tableContext={tableContext}
          viewName={name}
        />
      )}
    </Pill>
  )
}
